import * as _ from 'lodash'
import {IDateRange, MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {
    WB_PeriodRow,
    WB_PlanRow,
    WB_PlanTypeEventTypeRow,
    WB_ProductGroupRow,
    WB_TPM_EventProductGroupRow, WB_TPM_EventProductRow, WB_TPM_EventRow,
    WB_TPM_EventSpendRow
} from "../PA.Core/PAdbSchemaRows";
import {TPMEventBO} from "./TPMEventBO";
import {ITPMEventSpend} from "../PA.TPM.Core/PA.TPM.IF.TPM.EventSpend.Aspects";
import {PASearch} from "../PA.Core/PASearch";
import {TPMEventBOStandardPolicy} from "./TPMEventBO.StdPolicy";
import {ErrorMessage_restate, ValidateDateRange, WarningMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {TPMEventSpend} from "./TPMEventBO.ITPMEventSpend";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {
    esWB_Period,
    esWB_Plan,
    esWB_Plan_Type_Event_Type
} from "../PA.Core/PAdbSchema";
import {
    Status_Type_Approved,
    Status_Type_PendingApproval,
    Status_Type_Revised,
    Status_Type_RevisionsDenied
} from "../PA.TPM.Core/TPM.Constants";


export class TPMEventBOValidations {

    static Validate(aBO: TPMEventBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            if (!aBO.WB_TPMEvent.isActive){
                resolve()
                return
            }


            TPMEventBOValidations.ValidateEventFields(aBO)
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    // Validate Event Soend Fields
                    return TPMEventBOValidations.ValidateEventSpend(aBO)
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    // Validate Tactic Fields
                    return TPMEventBOValidations.ValidateEventPPGOverlap(aBO)
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    // Validate Tactic Fields
                    return TPMEventBOValidations.ValidateSpendAmount(aBO)
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    // Validate Product Instore dates
                    return TPMEventBOValidations.ValidateEventPrdOverlap(aBO)
                })
                .then((ignore) => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    return TPMEventBOValidations.ValidateProductGroupCoverage(aBO)
                })
                .then((ignore) => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    // Validate Next..
                    // return nextValidation Function... and remove resolve().. (follow pattern)
                    resolve()
                })

                .catch((err) => {
                    error(err)
                })
        })
    }


    static ValidateBeforeDelete(aBO: TPMEventBO): Promise<void> {

        return new Promise<void>((resolve, error) => {

            let anEventPolicy: TPMEventBOStandardPolicy = aBO.PolicyCollection.Event

            ErrorMessage_restate(aBO.DeleteMessageProvider, anEventPolicy && !anEventPolicy.bIsEditor,
                "UserIsntEditor", "User doesn't have Edit Access to Delete Event")

            ErrorMessage_restate(aBO.DeleteMessageProvider, !aBO.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsPreApproval,
                "CantDeletePostApproval", "Unable to delete Event that has been Approved")

            resolve()
        })
    }


    //  Name the functions reasonably and put them in the top Validate Function.
    //

    static ValidateEventFields(aBO: TPMEventBO): Promise<void> {

        return new Promise((resolve, error) => {

            let Evt = aBO.WB_TPMEvent
            let EvtType = Evt.WB_EventTypeRow
            let PlanPeriod = Evt.WB_PlanRow.WB_PeriodRow
            let PlanPeriodRange: IDateRange = {StartDt: PlanPeriod.PeriodStartDt, EndDt: PlanPeriod.PeriodEndDt}
            let dateValidateOptions = {
                bLogError: true,
                validateRange: PlanPeriodRange,
                validationRangeName: 'valid Planning Period'
            }

            //Check required fields
            let bEventNameEmpty = false;
            let bEventTypeEmpty = false
            let bInitialStatusEmpty = false
            if (_.isEmpty(Evt.cif.EVENT_NAME)) {
                bEventNameEmpty = true
            }

            if (_.isUndefined(Evt.cif.WB_EVTTYPE_ID) || _.isNull(Evt.cif.WB_EVTTYPE_ID)) {
                bEventTypeEmpty = true
            }

            if (_.isUndefined(Evt.cif.WORKFLOW_STATUS_ID) || _.isNull(Evt.cif.WORKFLOW_STATUS_ID)) {
                bInitialStatusEmpty = true
            }

            // Check Dates
            if (EvtType.bInStoreDatesShowInd && EvtType.cif.INSTOREDATES_POLICY == 'UserInput') {
                ValidateDateRange(aBO.ValidateMessageProvider, 'Event InStore Dates', Evt.InStoreStartDt, Evt.InStoreEndDt, dateValidateOptions)
            }

            if (EvtType.bShipmentDatesShowInd && EvtType.cif.SHIPMENTDATES_POLICY == 'UserInput') {
                ValidateDateRange(aBO.ValidateMessageProvider, 'Event Shipment Dates', Evt.ShipmentStartDt, Evt.ShipmentEndDt, dateValidateOptions)
            }

            if (EvtType.bOrderDatesShowInd && EvtType.cif.ORDERDATES_POLICY == 'UserInput') {
                ValidateDateRange(aBO.ValidateMessageProvider, 'Event Order Dates', Evt.OrderStartDt, Evt.OrderEndDt, dateValidateOptions)
            }

            if (EvtType.bDistributionDatesShowInd && EvtType.cif.DISTRIBUTIONDATES_POLICY == 'UserInput') {
                ValidateDateRange(aBO.ValidateMessageProvider, 'Event Distribution Dates', Evt.DistributionStartDt, Evt.DistributionEndDt, dateValidateOptions)
            }

            let EvtPrdGrpsIncludeIndFlag = false
            let productGroupSelectedFlag = false
            let message: string[] = []
            let EvtPrdGrps = _.filter(aBO.WB_TPMEvent.WB_TPM_EventProductGroupRows, (x: WB_TPM_EventProductGroupRow) => x.isActive)
            let arrTPMEvtSpendRowsToBeValidated: WB_TPM_EventSpendRow[] = _.filter(
                aBO.WB_TPMEvent.WB_TPM_EventSpendRows,
                (aTPMEvtSRow: WB_TPM_EventSpendRow) => (
                    aTPMEvtSRow.cif.PAID_IN_FULL_IND !== "1" &&
                    !aTPMEvtSRow.WB_WorkflowStatusRow.StatusTypeCancelled &&
                    aTPMEvtSRow.isActive &&
                    aTPMEvtSRow.cif.DELETED_IND !== "1"
                )
            )
            _.forEach(arrTPMEvtSpendRowsToBeValidated, (z: WB_TPM_EventSpendRow) => {
                let EvtSpndPrdGrp = _.filter(z.cif.WB_TPM_EventSpendPrdGrpRows, y => (y.cif.INCLUDE_IND == "1" &&
                    y.isActive))
                if (EvtSpndPrdGrp.length <= 0) {
                    EvtPrdGrpsIncludeIndFlag = true
                    message.push(z.cif.EVENT_SPEND_NAME)
                }

            })

            let bIsPromotedPriceNotSet = false;
            let bIsEDLPPriceNotSet = false
            let bEDLPCoverageFactorError = false

            _.forEach(EvtPrdGrps, (aRow: WB_TPM_EventProductGroupRow) => {
                let PrdGrpName = aRow.WB_ProductGroupRow.cif.PRODUCT_GROUP_NAME

                if (EvtType.bCoverageFactorShowInd && EvtType.cif.COVERAGEFACTOR_LEVEL == 'ProductGroup') {
                    // TODO: Add Coverage Factor Policy to allow for showing field in readonly state.
                    if ((EvtType.cif.CALC_VOLUMELAYER_ID === 'EDLP') && (aRow.COVERAGE_FACTOR_BASE_100 != 100)) {
                        bEDLPCoverageFactorError = true
                    }
                }

                if (EvtType.bPGPromotedPriceShowInd && EvtType.cif.PGPROMOTEDPRICE_POLICY == 'UserInput') {
                    if (aRow.cif.PROMOTED_PRICE == 0) {
                        bIsPromotedPriceNotSet = true
                    }
                }

                if (EvtType.bPGEDLPPriceShowInd && EvtType.cif.PGEDLPPRICE_POLICY == 'UserInput') {
                    if (aRow.cif.EDLP_PRICE == 0) {
                        bIsEDLPPriceNotSet = true
                    }
                }

            })

            ErrorMessage_restate(aBO.ValidateMessageProvider, EvtPrdGrpsIncludeIndFlag, 'EvtPrdGrpsIncludeIndFlag', `Event cannot be saved: At least one product group must be included in tactic: ${message.join(',')}`)
            ErrorMessage_restate(aBO.ValidateMessageProvider, bEventNameEmpty, 'EventNameEmpty', "Please enter promotion name")
            ErrorMessage_restate(aBO.ValidateMessageProvider, bEventTypeEmpty, 'EventTypeEmpty', "Please enter promotion type")
            ErrorMessage_restate(aBO.ValidateMessageProvider, bInitialStatusEmpty, 'EventInitialStatusEmpty', "Please enter promotion status")
            ErrorMessage_restate(aBO.ValidateMessageProvider, bEDLPCoverageFactorError, 'EDLPCoverageFactor100', "Coverage Percentage should be 100")
            WarningMessage_restate(aBO.ValidateMessageProvider, bIsPromotedPriceNotSet, 'PromotedPriceNotSet', "Promoted Price is 0.00")
            WarningMessage_restate(aBO.ValidateMessageProvider, bIsPromotedPriceNotSet, 'EDLPPriceNotSet', "EDLP Price is 0.00")

            resolve()
        })
    }

    static ValidateSpendAmount(aBO: TPMEventBO): Promise<void> {
        return new Promise((resolve, error) => {
            let isSpendError = false
            let EvtSpends: any = _.filter(aBO.WB_TPMEvent.WB_TPM_EventSpendRows, (x: ITPMEventSpend) => x.isActive)
            // let EvtSpendsRows: any = _.filter(aBO.WB_TPMEvent.WB_TPM_EventSpendRows, (x: ITPMEventSpend) => x.isActive)
            let greaterThanOneItems = ""

            async function RunEventSpendValidateFunctions() {
                //WB_TPM_EventSpendPrdGrpRows
                _.forEach(EvtSpends, (aRow: any) => {
                    _.forEach(aRow.WB_TPM_EventSpendPrdGrpRows, (bRow: any) => {
                        if (bRow.isActive && (aRow.RATE_UOM === 'ListSales') && bRow.RATE_AMT > 1) {
                            isSpendError = true
                            if (greaterThanOneItems) {
                                greaterThanOneItems = greaterThanOneItems + ',' + bRow.WB_ProductGroupRow.PRODUCT_GROUP_NAME
                            } else {
                                greaterThanOneItems = greaterThanOneItems + bRow.WB_ProductGroupRow.PRODUCT_GROUP_NAME
                            }
                        }
                    });
                });
                if (isSpendError) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'ValidAmount',
                            type: MessageType.Error,
                            title: "Percent-based discount rate entered is greater than 1 for " + greaterThanOneItems + ". Users should enter rates as decimals (e.g. 10% should be entered as 0.10)",
                            description: "",
                            subtitle: "",
                            count: 0
                        })

                } else {
                    aBO.ValidateMessageProvider.removeMessage('ValidAmount')
                }


            }

            RunEventSpendValidateFunctions()
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static ValidateEventSpend(aBO: TPMEventBO): Promise<void> {

        return new Promise((resolve, error) => {

            let EvtSpends = _.filter(aBO.TPMEventSpends, (x: ITPMEventSpend) => x.isActive)
            let Evt = aBO.WB_TPMEvent
            let EvtType = Evt.WB_EventTypeRow

            async function RunEventSpendValidateFunctions() {
                //
                for (let iEventSpend of aBO.TPMEventSpends) {
                    let oEventSpend: TPMEventSpend = <any>iEventSpend
                    await oEventSpend.Validate({})
                    aBO.ValidateMessageProvider.addMessages(oEventSpend.ValidateMessageProvider.Messages)
                }
            }

            RunEventSpendValidateFunctions()
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })


        })

    }

    static async ValidateEventPPGOverlap(aBO: TPMEventBO): Promise<void> {
        let Evt = aBO.WB_TPMEvent

        let ignoreInStorePPGOverlapPolicy: boolean = (Evt.WB_EventTypeRow.cif.INSTORE_PGOVERLAP_POLICY == "None") ? true : false
        let ignoreShipmentPPGOverlapPolicy: boolean = (Evt.WB_EventTypeRow.cif.SHIPMENT_PGOVERLAP_POLICY == "None") ? true : false
        const vUI_TPMEvent_PPG_columns = {
            WB_PLAN_ID:             {type: "number"},
            WB_TEVT_ID:             {type: "number"},
            WB_EVTTYPE_ID:          {type: "number"},
            WB_CUST_ID_SUBPLANNING: {type: "number"},
            WB_PRDGRP_ID:           {type: "number"},
            INSTORE_START_DT:       {type: "string"},
            INSTORE_END_DT:         {type: "string"},
            SHIPMENT_START_DT:      {type: "string"},
            SHIPMENT_END_DT:        {type: "string"},
            STATUS_TYPE:            {type: "string"}
        }

        // Don't check overlap when Cancelling an Event
        if (aBO.PrimaryWorkflowProcessor.NextState.StatusTypeCancelled) {
            return
        }


        let bLogAsError = aBO.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsPostApproval || aBO.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsRequestingApproval ||
            aBO.PrimaryWorkflowProcessor.NextState.StatusTypeIsRequestingApproval || aBO.PrimaryWorkflowProcessor.NextState.StatusTypeApproved

        let findStatusTypes = [Status_Type_Approved, Status_Type_Revised, Status_Type_PendingApproval, Status_Type_RevisionsDenied]

        let arrPrdGrps: number[] = _.map(aBO.ProductGroups, (aRow: WB_ProductGroupRow) => aRow.cif.WB_PRDGRP_ID)
        if (_.isEmpty(arrPrdGrps))
            return


        let query: any = {}

        let bIncludeSubPlanningCust: boolean = false
        if (Evt.cif.WB_CUST_ID_SUBPLANNING > 0)
            bIncludeSubPlanningCust = true

        query.WB_PLAN_ID = Evt.cif.WB_PLAN_ID
        query.WB_TEVT_ID = {neq: Evt.cif.WB_TEVT_ID}
        query.WB_PRDGRP_ID = {inq: arrPrdGrps}
        query.WB_EVTTYPE_ID = Evt.cif.WB_EVTTYPE_ID
        query.STATUS_TYPE = {inq: findStatusTypes}
        if (bIncludeSubPlanningCust)
            query.WB_CUST_ID_SUBPLANNING = {inq: [Evt.cif.WB_CUST_ID_SUBPLANNING, 0]}

        if (!ignoreInStorePPGOverlapPolicy) {

            let queryInStore: any = _.cloneDeep(query)
            queryInStore.INSTORE_START_DT = {lt: Evt.cif.INSTORE_END_DT}
            queryInStore.INSTORE_END_DT = {gt: Evt.cif.INSTORE_START_DT}

            let arrRows = await PASearch.find(
                'vUI_TPMEvent_PPG',
                queryInStore,
                vUI_TPMEvent_PPG_columns,
                [],
                0,
                [])

            if (!_.isEmpty(arrRows)) {
                let arrEvtNames: string = _.map(_.sortedUniqBy(arrRows, 'EVENT_ID'), 'EVENT_ID').join(', ')
                if (bLogAsError)
                    ErrorMessage_restate(aBO.ValidateMessageProvider, true, 'InStoreDateOverlap', "This promotion overlaps with " + arrEvtNames + " having the same customer and/or sub-customer and performance dates, as well as at least one of the same PPGs")
                else
                    WarningMessage_restate(aBO.ValidateMessageProvider, true, 'InStoreDateOverlap', "This promotion overlaps with " + arrEvtNames + " having the same customer and/or sub-customer and performance dates, as well as at least one of the same PPGs")
            }
        }

        if (!ignoreShipmentPPGOverlapPolicy) {

            let queryShipment: any = _.cloneDeep(query)
            queryShipment.SHIPMENT_START_DT = {lt: Evt.cif.SHIPMENT_END_DT}
            queryShipment.SHIPMENT_END_DT = {gt: Evt.cif.SHIPMENT_START_DT}

            let arrShipmentRows = await PASearch.find(
                'vUI_TPMEvent_PPG',
                queryShipment,
                vUI_TPMEvent_PPG_columns,
                [],
                0,
                []);

            if (!_.isEmpty(arrShipmentRows)) {
                let arrEvtNames: string = _.map(_.sortedUniqBy(arrShipmentRows, 'EVENT_ID'), 'EVENT_ID').join(', ')
                if (bLogAsError)
                    ErrorMessage_restate(aBO.ValidateMessageProvider, true, 'ShipmentDateOverlap', "This promotion overlaps with " + arrEvtNames + " having the same customer and/or sub-customer and shipment dates, as well as at least one of the same PPGs")
                else
                    WarningMessage_restate(aBO.ValidateMessageProvider, true, 'ShipmentDateOverlap', "This promotion overlaps with " + arrEvtNames + " having the same customer and/or sub-customer and shipment dates, as well as at least one of the same PPGs")
            }
        }

    }

    static async ValidateEventPrdOverlap(aBO: TPMEventBO): Promise<void> {
        let Evt = aBO.WB_TPMEvent

        let ignoreShipmentPrdOverlapPolicy: boolean = (Evt.WB_EventTypeRow.cif.SHIPMENT_PRDOVERLAP_POLICY == "None") ? true : false
        let bLegacyPlan: boolean = (Evt.WB_PlanRow.WB_PlanTypeRow.cif.DISPLAY_HANDLING_METHOD_ID == "Legacy") ? true : false

        const vUI_TPMEvent_Prd_columns = {
            WB_PLAN_ID:             {type: "number"},
            WB_TEVT_ID:             {type: "number"},
            WB_EVTTYPE_ID:          {type: "number"},
            WB_CUST_ID_SUBPLANNING: {type: "number"},
            WB_PROD_ID:             {type: "number"},
            INSTORE_START_DT:       {type: "string"},
            INSTORE_END_DT:         {type: "string"},
            SHIPMENT_START_DT:      {type: "string"},
            SHIPMENT_END_DT:        {type: "string"},
            STATUS_TYPE:            {type: "string"}
        }

        // Don't check overlap when Cancelling an Event
        if (aBO.PrimaryWorkflowProcessor.NextState.StatusTypeCancelled) {
            return
        }

        let bLogAsError = aBO.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsPostApproval || aBO.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsRequestingApproval ||
            aBO.PrimaryWorkflowProcessor.NextState.StatusTypeIsRequestingApproval || aBO.PrimaryWorkflowProcessor.NextState.StatusTypeApproved

        let findStatusTypes = [Status_Type_Approved, Status_Type_Revised, Status_Type_PendingApproval, Status_Type_RevisionsDenied]

        let prdIds = _.map(_.filter(
            aBO.WB_TPMEvent.WB_TPM_EventProductRows,
            (aRow: WB_TPM_EventProductRow) =>
                (aRow.cif.ROW_TYPE == 'Display' && aRow.isActive)
        ), (prdRecord) => {
            return prdRecord.cif.WB_PROD_ID
        })

        if (_.isEmpty(prdIds))
            return

        if (!bLegacyPlan) {
            if (!ignoreShipmentPrdOverlapPolicy) {

                let queryShipment: any = {}
                queryShipment.WB_PLAN_ID = Evt.cif.WB_PLAN_ID
                queryShipment.WB_TEVT_ID = {neq: Evt.cif.WB_TEVT_ID}
                queryShipment.WB_PROD_ID = {inq: prdIds}
                queryShipment.WB_EVTTYPE_ID = Evt.cif.WB_EVTTYPE_ID
                queryShipment.STATUS_TYPE = {inq: findStatusTypes}
                queryShipment.SHIPMENT_END_DT = {gt: Evt.cif.SHIPMENT_START_DT}
                queryShipment.SHIPMENT_START_DT = {lt: Evt.cif.SHIPMENT_END_DT}

                if (Evt.WB_EventTypeRow.cif.SHIPMENT_PRDOVERLAP_POLICY == "ByEventTypeAndCustomer") {
                    if (Evt.cif.WB_CUST_ID_SUBPLANNING > 0)
                        queryShipment.WB_CUST_ID_SUBPLANNING = Evt.cif.WB_CUST_ID_SUBPLANNING
                    queryShipment.WB_CUST_ID_PLANNING = Evt.cif.WB_CUST_ID_PLANNING
                }

                let arrRows = await PASearch.find(
                    'vUI_TPMEvent_Prd',
                    queryShipment,
                    vUI_TPMEvent_Prd_columns,
                    [],
                    0,
                    [])

                if (!_.isEmpty(arrRows)) {
                    let arrEvtNames: string = _.uniq(_.map(_.sortedUniqBy(arrRows, 'EVENT_ID'), 'EVENT_ID')).join(', ')
                    let finalProducts = _.uniq(_.map(arrRows, (prodRow) => {
                        return prodRow.PRODUCT_ID
                    }))

                    if (bLogAsError)
                        ErrorMessage_restate(aBO.ValidateMessageProvider,
                            true,
                            'ShipmentDateOverlap',
                            `${finalProducts.join(', ')} product(s) within the event overlap with ${arrEvtNames} event. Please remove this product or change the planning dates so they do not overlap with other shipper events`)
                    else
                        WarningMessage_restate(aBO.ValidateMessageProvider,
                            true,
                            'ShipmentDateOverlap',
                            `${finalProducts.join(', ')} product(s) within the event overlap with ${arrEvtNames} event. Please remove this product or change the planning dates so they do not overlap with other shipper events`)

                }
            }
        }
    }

    static async ValidateEventCopy(aPlanId: number, oldBO: TPMEventBO): Promise<void> {
        let plan: WB_PlanRow = await oldBO.dbContext.find(esWB_Plan, aPlanId)
        let planTypeId: number = plan.cif.WB_PLANM_ID

        let planTypeEventTypeRows: WB_PlanTypeEventTypeRow[] =
            await oldBO.dbContext.findAll(esWB_Plan_Type_Event_Type, {
                where: {
                    WB_PLANM_ID: planTypeId
                }
            })

        let periodRow: WB_PeriodRow = await oldBO.dbContext.find(esWB_Period, plan.cif.WB_PERIOD_ID)
        let planPeriodStartDt = periodRow.PeriodStartDt

        let evtTypeId = oldBO.WB_TPMEvent.cif.WB_EVTTYPE_ID
        let planTypeEventTypeRow: WB_PlanTypeEventTypeRow = _.first(_.filter(planTypeEventTypeRows, (aRow: WB_PlanTypeEventTypeRow) => {
            return aRow.cif.WB_EVTTYPE_ID == evtTypeId
        }))
        let bValidCopyEvent: boolean = false

        if (!_.isUndefined(planTypeEventTypeRow)) {
            let planTypeEventTypeEffectiveEndDt: Date = planTypeEventTypeRow.EffectiveEndDt
            if (DateUtils.isGreaterThanEqual(planTypeEventTypeEffectiveEndDt, planPeriodStartDt))
                bValidCopyEvent = true
        }

        if (!bValidCopyEvent) {
            ErrorMessage_restate(oldBO.ValidateMessageProvider,
                true,
                'ValidCopyEvent',
                `TPM Event cannot be created because the selected event type: `
                + oldBO.WB_TPMEvent.WB_EventTypeRow.cif.TYPE_NAME +
                ` is not valid for the selected plan: ` + plan.cif.PLAN_NAME)

        }
    }


    static ValidateProductGroupCoverage(aBO: TPMEventBO): void {
        let Evt = aBO.WB_TPMEvent
        if (Evt.WB_EventTypeRow.cif.COVERAGEFACTOR_WARNING_SHOW_IND == "1" && Evt.WB_EventTypeRow.cif.COVERAGEFACTOR_SHOW_IND == '1') {
            if (_.filter(Evt.WB_TPM_EventProductGroupRows, aRow => aRow.cif.COVERAGE_FACTOR >= 1).length) {

                WarningMessage_restate(aBO.ValidateMessageProvider,
                    true,
                    'CoveragePct',
                    {
                        Title: "100% Coverage Alert",
                        Desc: `Coverage % for this event is 100% and above, please review to confirm that is correct. `
                    })

            }
        }


    }


}
